import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpContext} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AddItemToOrderRequest, BillResponse} from '@core/models';
import {SKIP_LOADING} from '@core/interceptors/loading.interceptor';

@Injectable({
  providedIn: 'root'
})
export class ApiOrder {
  baseUrl = '/middleware';
  private http = inject(HttpClient);

  addProductToOrder(body: Array<AddItemToOrderRequest>): Observable<any> {
    return this.http.post<{ status: string }>(`${this.baseUrl}/restaurant/orders/items`, body);
  }

  getOrderStatus(orderId: string, customerId: string): Observable<BillResponse> {
    return this.http.get<BillResponse>(`${this.baseUrl}/restaurant/order/${orderId}/customer/${customerId}/status`, {
      context: new HttpContext().set(SKIP_LOADING, true)
    });
  }

  cancelOrderItem(orderProductId: number): Observable<any> {

    return this.http.delete(`${this.baseUrl}/restaurant/order/item/${orderProductId}`);
  }


  requestBill(orderId: string, customer: string): Observable<any> {

    return this.http.put(`${this.baseUrl}/restaurant/orders/${orderId}/request-bill`, {customer});
  }

  callWaiter(customer: string): Observable<any> {

    return this.http.put(`${this.baseUrl}/restaurant/customers/${customer}/call-waiter`, null);
  }
}
